const defaultVariantsForms: any[] = [

    {
        "maxItems": 1,
        "visible": true,
        "bizType": "saleProp",
        "prefix": "custom_",
        "textMaxLength": 50,
        "locale": {
          "cancel": "Cancel",
          "image": "Image",
          "cropFromList": "Crop from uploaded images",
          "maximumImage": "Max {v} images for each variant.",
          "images": "Images",
          "upload": {
            "thumbnail": "Thumbnail",
            "clickHere": "Click here",
            "cropSizeTip": "Dimensions should be between 330x330 and 2000x2000",
            "cropError": "Image clipping failed",
            "duplicate": "Duplicate Pictures",
            "title": "Upload",
            "uploadError": "Upload Error",
            "saveClose": "save and close",
            "addPicture": "Add Picture",
            "mainImage": "Main Image",
            "maxSizeError": "Image size should not exceed 2M. Upload a different image.",
            "uploadTip1": "Drag and drop pictures below to upload.",
            "width": "width",
            "uploadTip4": "See Guidelines here",
            "uploadTip2": "Add at least 3 images of your product from different angles.",
            "uploadTip3": "Maximum 8 pictures. Size between 500x500 and 2000x2000 px. Obscene image is strictly prohibited.",
            "uploadTips": "Drag and drop pictures below to upload. Maximum 8 pictures, size between 500x500 and 2000x2000 px. Obscene image is strictly prohibited.",
            "mediaCenter": "Media Center",
            "toCopy": "to copy images from above SKU.",
            "height": "height"
          },
          "addImage": "Add Image",
          "confirmRemoveImage": "Are you sure to remove image?",
          "type": "lazadaCustomSaleProp",
          "variation": "Variant",
          "useDifferent": "Use a different thumbnail",
          "cropNew": "Upload a new image",
          "tipContent": "Duplicate current value, please modify",
          "view": "Upload Image",
          "manualDeletePrompt": "tr(manual_delete_prompt@customSaleProp)",
          "addVariation": "Add Variation",
          "name": "Variant Name",
          "options": "Total Variants",
          "deletePrompt": "Are you sure want to delete it?",
          "confirmChangeImage": "Are you sure to change image?",
          "tipTitle": "Tips",
          "ok": "Confirm",
          "collapse": "Collapse",
          "inputPlaceholder": "Please type or select"
        },
        "customize": true,
        "required": false,
        "valueMaxLength": 20,
        "imageConfig": {
          "imageMinWidth": 330,
          "imageMaxWidth": 5000,
          "imageLength": 8,
          "imageMinHeight": 330,
          "goldLog": "/LazadaSellerCenter.AddProduct.Image",
          "imageUploadUrl": "/image/upload",
          "newMediaCenter": true,
          "imagePropName": "__images__",
          "imageSize": 2048,
          "imageDownloadUrl": "/product/image/encode",
          "imageMaxHeight": 5000,
          "mediaCenterHost": "https://sellercenter.daraz.pk/mediacenter"
        },
        "valueLimit": 200,
        "hasSort": true,
        "readonly": false,
        "tipForDeleteEnabled": false,
        "name": "customSaleProp",
        "uiType": "customSaleProp",
        "maxPerItem": 200,
        "attributes": [],
        "thumbnailConfig": {
          "imageMaxWidth": 1920,
          "imageMinWidth": 330,
          "imageLength": 1,
          "imageMinHeight": 330,
          "imageUploadUrl": "/image/upload",
          "imagePropName": "color_thumbnail",
          "imageSize": 2048,
          "imageDownloadUrl": "/product/image/encode",
          "imageMaxHeight": 1920,
          "mediaCenterHost": "https://sellercenter.daraz.pk/mediacenter"
        },
        "dataSource": [],
        "value": [],
        "group": "sale",
        "info": {
          "help": "Type and press enter to create, or just to quickly select standard values"
        }
      }
      

]

export default defaultVariantsForms;